const measurementsState = {
    loadingInfo: false,
    errorInfo: false,
    info: {},
    loading: false,
    error: false,
    hourlyBuilding: {},
    hourlyApartment: {},
    hourlyRoom: {},
    dailyBuilding: {},
    dailyApartment: {},
    dailyRoom: {},
    weeklyBuilding: {},
    weeklyApartment: {},
    weeklyRoom: {},
    monthlyBuilding: {},
    monthlyApartment: {},
    monthlyRoom: {}
}
const measurementsReducer = (state = measurementsState, action) => {
    switch (action.type) {
        case 'REQUEST_MEASUREMENTS_INFO':
            return Object.assign({}, state, {
                errorInfo: false,
                loadingInfo: true
            })

        case 'REQUEST_MEASUREMENTS_INFO_SUCCESS':
            return Object.assign({}, state, {
                info: {
                    ...state.info,
                    [action.appId]: action.payload
                },
                errorInfo: false,
                loadingInfo: false
            })

        case 'REQUEST_MEASUREMENTS_INFO_FAIL':
            return Object.assign({}, state, {
                loadingInfo: false,
                errorInfo: true
            })

        case 'REQUEST_MEASUREMENTS':
            return Object.assign({}, state, {
                loading: true,
                error: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_HOURLY_BUILDING':
            return Object.assign({}, state, {
                hourlyBuilding: {
                    ...state.hourlyBuilding,
                    [action.appId]: action.payload
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_HOURLY_APARTMENT':
            return Object.assign({}, state, {
                hourlyApartment: {
                    ...state.hourlyApartment,
                    [action.appId]: {
                        ...state.hourlyApartment[action.appId],
                        [action.apartment]: action.payload
                    }
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_HOURLY_ROOM':
            return Object.assign({}, state, {
                hourlyRoom: {
                    ...state.hourlyRoom,
                    [action.appId]: {
                        ...state.hourlyRoom[action.appId],
                        [action.apartment + '_' + action.room]: action.payload
                    }
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_DAILY_BUILDING':
            return Object.assign({}, state, {
                dailyBuilding: {
                    ...state.dailyBuilding,
                    [action.appId]: action.payload
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_DAILY_APARTMENT':
            return Object.assign({}, state, {
                dailyApartment: {
                    ...state.dailyApartment,
                    [action.appId]: {
                        ...state.dailyApartment[action.appId],
                        [action.apartment]: action.payload
                    }
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_DAILY_ROOM':
            return Object.assign({}, state, {
                dailyRoom: {
                    ...state.dailyRoom,
                    [action.appId]: {
                        ...state.dailyRoom[action.appId],
                        [action.apartment + '_' + action.room]: action.payload
                    }
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_WEEKLY_BUILDING':
            return Object.assign({}, state, {
                weeklyBuilding: {
                    ...state.weeklyBuilding,
                    [action.appId]: action.payload
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_WEEKLY_APARTMENT':
            return Object.assign({}, state, {
                weeklyApartment: {
                    ...state.weeklyApartment,
                    [action.appId]: {
                        ...state.weeklyApartment[action.appId],
                        [action.apartment]: action.payload
                    }
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_WEEKLY_ROOM':
            return Object.assign({}, state, {
                weeklyRoom: {
                    ...state.weeklyRoom,
                    [action.appId]: {
                        ...state.weeklyRoom[action.appId],
                        [action.apartment + '_' + action.room]: action.payload
                    }
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_MONTHLY_BUILDING':
            return Object.assign({}, state, {
                monthlyBuilding: {
                    ...state.monthlyBuilding,
                    [action.appId]: action.payload
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_MONTHLY_APARTMENT':
            return Object.assign({}, state, {
                monthlyApartment: {
                    ...state.monthlyApartment,
                    [action.appId]: {
                        ...state.monthlyApartment[action.appId],
                        [action.apartment]: action.payload
                    }
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_SUCCESS_MONTHLY_ROOM':
            return Object.assign({}, state, {
                monthlyRoom: {
                    ...state.monthlyRoom,
                    [action.appId]: {
                        ...state.monthlyRoom[action.appId],
                        [action.apartment + '_' + action.room]: action.payload
                    }
                },
                error: false,
                loading: false
            })

        case 'REQUEST_MEASUREMENTS_FAIL':
            return Object.assign({}, state, {
                loading: false,
                error: true
            })

        default:
            return state
    }
}

export default measurementsReducer


// WEBPACK FOOTER //
// ./src/reducers/measurementsReducer.js